export default __webpack_public_path__ + "static/media/editIcon.c19ca685.svg";